import { TreatmentQuestionStatus } from './treatment-question';

export type TreatmentQuestionStatusFilter = TreatmentQuestionStatus;
